import { render, staticRenderFns } from "./WorkFloHeader.vue?vue&type=template&id=4a723eb4&"
import script from "./WorkFloHeader.vue?vue&type=script&lang=js&"
export * from "./WorkFloHeader.vue?vue&type=script&lang=js&"
import style0 from "./WorkFloHeader.vue?vue&type=style&index=0&id=4a723eb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports